import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import * as urlSlug from 'url-slug'

const AgendaItem = ({agendaItem, lang}) => {
    const dia_inicio = new Date(agendaItem.data_inicio).toLocaleDateString("pt-PT", {
        day: "2-digit"
    })
    const dia_fim = new Date(agendaItem.data_fim).toLocaleDateString("pt-PT", {
        day: "2-digit"
    })
    const mes_inicio = new Date(agendaItem.data_inicio).toLocaleDateString("pt-PT", {
        month: "short"
    }).replace('.', '')
    const mes_fim = new Date(agendaItem.data_fim).toLocaleDateString("pt-PT", {
        month: "short"
    }).replace('.', '')

    let { pathname } = useLocation()

    return (
        <div className="timeline__item" title={agendaItem.titulo}>
            <div className="timeline__content">
                <div className="evDate">
                    <span className="evDay">{dia_inicio}</span>
                    {(mes_inicio === mes_fim && Number(dia_fim) !== Number(dia_inicio)) ? null: <span className="evMonth" id="evMes">{mes_inicio}</span>}
                    {Number(dia_fim) !== Number(dia_inicio) ?
                        <>
                        <span className="evDay">-</span>
                        <span className="evDay">{dia_fim}</span>
                        <span className="evMonth" id="evMes">{mes_fim}</span>
                        </>
                        : null}

                </div>
                <div className="description">
                    <Link to={lang === "pt" ?
                        "/pt/eventos/"+urlSlug.convert(`${agendaItem.titulo} ${agendaItem.event_id}`)
                        : "/en/events/"+urlSlug.convert(`${agendaItem.titulo} ${agendaItem.event_id}`)
                    } state={{from: pathname}}>{agendaItem.titulo.length > 40 ? `${agendaItem.titulo.substring(0,35)}...` : agendaItem.titulo}</Link>
                </div>
            </div>
        </div>
    )
}

export default AgendaItem
